export default __webpack_public_path__ + "static/media/img7.833a7e15.png";